import { ActionIcon, Box, Group, Text } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import "./NCENavbarLink.css";

export default function NCENavbarLink({ title, url, icon, color, active }) {
  const navigate = useNavigate();
  
  return (
    <Box p={8} className={`navbar-link ${active ? "active" : ""}`} onClick={() => navigate(url)}>
      { active && <div className="active-box" /> }
      <Group>
        <ActionIcon variant="light" color={color} size="lg">
          {icon}
        </ActionIcon>
		    { active && <Text c={color} fw={700}>{title}</Text> }
        { !active && <Text fw="md" c={color}>{title}</Text> }
      </Group>
    </Box>
  );
}